
import React, { Component } from 'react';
import { DialogContainer } from 'react-md';
import './OverviewDialog.scss';
import {
  Wizard
} from '../';

export default class OverviewDialog extends Component {

  render() {
    const { visible, onHide, title, data } = this.props;
  
    return (
      <DialogContainer
        id="overview-dialog"
        className="focus-dialog"
        visible={visible}
        fullPage
        aria-labelledby="overview-dialog-title"
        disableScrollLocking
      >
        <Wizard
          data={data}
          title={title}
          hide={onHide}
        />
      </DialogContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/OverviewDialog/OverviewDialog.jsx